import {Component} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {BtwAcademyHeader} from "./btw-academy-header/btw-academy-header";
import {BtwAcademyInfoCard} from "./models/btw-academy-info-card";
import {BoxItemFlip} from "../../components/display/box-item-flip/box-item-flip";

@Component({
  selector: 'ro-btw-academy',
  standalone: true,
  imports: [
    TranslateModule,
    BtwAcademyHeader,
    BoxItemFlip
  ],
  styleUrls: ['./btw-academy.scss'],
  templateUrl: 'ro-btw-academy.html'
})
export class RoBtwAcademy {
  protected infoCards: BtwAcademyInfoCard[] = [
    {
      title: 'MiniTrooper Student Learning Program',
      imgClass: 'flip-card-btw-16',
      description: 'MiniTrooper Student Learning Program',
      content: 'Este un proiect educațional dezvoltat de BMW TechWorks România, dedicat formării și integrării tinerilor talentați în domeniul tehnologiei.\n' +
        'Programul oferă studenților oportunitatea de a combina studiul academic cu experiența practică într-un mediu real de lucru, descoperind cum se construiește inovația în cadrul unei companii globale de tehnologie.\n' +
        '\n' +
        'Studenții sunt implicați într-un program hibrid – desfășurat la sediul BMW TechWorks România din Cluj-Napoca și online – beneficiind de mentorat, activități aplicate și expunere la procesele reale ale industriei.\n' +
        'MiniTrooper reprezintă o experiență completă de învățare și dezvoltare profesională, concepută ca o rampă de lansare pentru o carieră în domeniul tehnologic.'
    }, {
      title: 'Science Café – laboratorul unde ideile și cercetarea prind viață',
      imgClass: 'flip-card-btw-10-large',
      description: 'Science Café',
      content: 'Este laboratorul de co-creare, cercetare și experimentare din cadrul BMW TechWorks România, dedicat studenților, profesorilor și tinerilor pasionați de tehnologie.\n' +
        'Aici se pot desfășura activități precum workshopuri, sesiuni de cercetare aplicată, prototipare, testare de concepte, hackathoane și inițiative de inovație dedicate tehnologiilor emergente – de la inteligență artificială și sustenabilitate, până la mobilitate digitală și software engineering.\n' +
        '\n' +
        'Laboratorul poate fi rezervat de către studenți în scopuri educaționale sau creative, pe bază de cerere trimisă la 👉 office@bmwtechworks.ro.\n' +
        'Un spațiu deschis pentru colaborare, cercetare și inovație – unde ideile se transformă în proiecte reale.'
    }
  ];
}
